import { render, staticRenderFns } from "./CalendarSidebar.vue?vue&type=template&id=3365c7aa&scoped=true"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js"
import style0 from "./CalendarSidebar.vue?vue&type=style&index=0&id=3365c7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3365c7aa",
  null
  
)

export default component.exports